export default {
  FULL: 'full',
  QUICK_START: 'quick_start'
}
